// extracted by mini-css-extract-plugin
export var closeButton = "_16-3";
export var header = "_16-0";
export var link = "_16-1";
export var retryButton = "_16-2";